import React, { useState } from "react";
import MainCalculatorsList from "../MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
import { CalculatorsType } from "../ConstantsEN";
import SharedHelmet from "../Helmet";
const TITLE = "Birthday Countdown Calculator - Calculate How Long Till My Birthday";
const DESCRIPTION = "Use our Birthday Countdown Calculator to find out how many days, months, and years are left until your next birthday. Enter your birthdate to get an accurate countdown of the time remaining until your special day.";
const KEYWORDS = "Birthday Countdown Calculator, Time Until My Birthday, Days Until My Birthday, Months Until My Birthday, Calculate Birthday Countdown, Time Until Next Birthday, Birthday Time Calculator";
const OG_URL = "https://do-calculate.com/calculator/en/birthday/";
function AgeCalculatorGregorian() {
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [age, setAge] = useState(null);
  const [error, setError] = useState(null);
  const handleDateChange = (event) => {
    setDateOfBirth(event.target.value);
  };
  function calculateAge() {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const birthDate = new Date(dateOfBirth);
    const birthMonth = birthDate.getMonth();
    const birthDay = birthDate.getDate();
    if (isNaN(birthDate)) {
      setError("Invalid date. Please enter a valid date");
      setAge(null);
      return null;
    }
    const nextBirthday = new Date(currentYear, birthMonth, birthDay);
    if (nextBirthday < currentDate) {
      nextBirthday.setFullYear(currentYear + 1);
    }
    const remainingTime = nextBirthday - currentDate;
    const seconds = Math.floor(remainingTime / 1000) % 60;
    const minutes = Math.floor(remainingTime / (1000 * 60)) % 60;
    const hours = Math.floor(remainingTime / (1000 * 60 * 60)) % 24;
    const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
    const leapYear = (year) =>
      (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    const daysInYear = leapYear(currentYear) ? 366 : 365;
    const age = {
      years: Math.floor(days / daysInYear),
      months: Math.floor((days % daysInYear) / 30),
      days: (days % daysInYear) % 30,
      hours,
      minutes,
      seconds,
    };
    setError(null);
    setAge(age);
    return age;
  }
  return (
    <div>
        <SharedHelmet
             TITLE={TITLE}
             DESCRIPTION={DESCRIPTION}
             KEYWORDS={KEYWORDS}
             OG_URL={OG_URL}
           />
      <div className="row">
        <div className="col-12 col-md-8">
                    <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Welcome to our Birthday Countdown Calculator! This tool helps you determine exactly how much time remains until your next birthday. By entering your birthdate, you'll get a detailed breakdown of the time left in days, months, and years, as well as hours, minutes, and seconds.
                </p>
                <p>
                  Key features of our Birthday Countdown Calculator include:
                  <ul>
                    <li><strong>Precise Countdown:</strong> Get an accurate countdown to your next birthday.</li>
                    <li><strong>Days, Months, and Years:</strong> See exactly how many days, months, and years are left.</li>
                    <li><strong>Hours, Minutes, and Seconds:</strong> Receive a detailed time breakdown down to the second.</li>
                    <li><strong>User-Friendly:</strong> Simply input your birthdate to view your countdown instantly.</li>
                  </ul>
                </p>
                <p>
                  To use the calculator, just enter your birthdate and click "Calculate". The tool will display the remaining time until your next birthday in a clear and easy-to-understand format.
                </p>
                <p>
                  This calculator is perfect for planning birthday celebrations, setting reminders, or just keeping track of time until your special day arrives. Whether you’re looking forward to a big celebration or just curious, our tool provides the exact countdown you need.
                </p>
                <p>
                  Start using the Birthday Countdown Calculator today and see how much time is left until you celebrate your next birthday!
                </p>
                <hr />
              </div>
              <br />
            </div>
            <hr />
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col">
                <label htmlFor="dateOfBirth" style={{ fontSize: "16px" }}>
                  {" "}
                  Enter Your Birthdate{" "}
                </label>
              </div>
              <div className="col">
                <div className="form-group">
                  <input
                    type="date"
                    id="dateOfBirth"
                    value={dateOfBirth}
                    onChange={handleDateChange}
                    className="form-control"
                    lang="en"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col text-center">
                <br />
                <button
                  className="btn btn-success"
                  style={{ fontSize: "20px" }}
                  onClick={calculateAge}
                >
                  Calculate
                </button>
                <br />
              </div>
              {error && <div style={{ color: "red" }}>{error}</div>}
              <hr />
              <div className="row">
                <RelatedLinks />
                <br />
                <hr />
              </div>
              <div className="row">
                <div className="col">
                  <br />
                  {age && (
                    <div>
                      <br />
                      <div
                        style={{
                          backgroundColor: "#D1E7DD",
                          borderColor: "#c3e6cb",
                          color: "#155724",
                          padding: "15px",
                          marginBottom: "20px",
                          borderRadius: "4px",
                        }}
                      >
                        {" "}
                        <label>
                          <b> Your Age Is: </b>
                          {age.years} years and {age.months} months and{" "}
                          {age.days} days and {age.hours} hours and{" "}
                          {age.minutes} minutes and {age.seconds} seconds
                        </label>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList
            CalculatorsTypeId={CalculatorsType.humanCalculators}
          ></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Understand the Time Remaining Until Your Birthday
              </div>
              <div className="info-section-body">
                <strong>
                  <h2 style={{ fontSize: "16px" }}>Calculate Time Until Your Birthday:</h2>
                </strong>
                <br />
                <p>
                  Use our tool to calculate exactly how many days, months, and hours are left until your birthday. Whether you want to know the number of days left until your next birthday or how many months remain, our service provides detailed results. Enter your birthdate to get a precise countdown until your special day.
                </p>
                <p>
                  Find out how much time is left until your birthday in a variety of formats. If your birthday is just around the corner, it will show in hours and minutes. If it is within the current month, the countdown will be in days. For birthdays further away, you will get the time remaining in months and days. Our system is based on accurate timekeeping to provide you with precise results.
                </p>
                <p>
                  This service can also show the time remaining until your birthday in relation to Greenwich Mean Time (GMT), allowing for an accurate comparison with local time zones. You can see how your local time aligns with GMT and determine the exact countdown to your birthday.
                </p>
                <strong>
                  <h2 style={{ fontSize: "16px" }}>How to Know the Exact Time Until Your Birthday:</h2>
                </strong>
                <br />
                <p>
                  Our calculator uses your Gregorian birthdate to provide an accurate count of the time remaining until your birthday. This is more precise than using other calendars and helps you plan celebrations effectively. Find out not just how much time is left, but also the specific details about your birthday countdown.
                </p>
                <p>
                  Our service offers versatility, including detailed birthday time calculations, and answers questions like how many days are left until your birthday, or how to determine your birthday countdown. Use it to stay informed and plan ahead for your special day.
                </p>
              </div>
            </div>
          </div>
          <br />
          <u>
            <h3>Frequently Asked Questions</h3>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  How can I calculate the time remaining until my birthday?
                </h3>
              </div>
              <div className="info-section-body">
                To calculate the time remaining until your birthday, you need to enter your birthdate into our calculator. The tool will then determine the number of days, months, and hours until your next birthday. It accounts for the current date and provides a detailed countdown.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  How do I know the exact number of days until my birthday?
                </h3>
              </div>
              <div className="info-section-body">
                Our calculator shows the exact number of days remaining until your birthday. By entering your birthdate, it calculates the precise countdown, including days, hours, and minutes. This allows you to know exactly how many days are left until your special day.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Can I find out how many months are left until my birthday?
                </h3>
              </div>
              <div className="info-section-body">
                Yes, our tool can show you the number of months remaining until your birthday. By inputting your birthdate, the calculator will provide you with a breakdown of the time left, including months and days, so you can plan accordingly.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  How can I calculate the time difference between my local time and GMT for my birthday?
                </h3>
              </div>
              <div className="info-section-body">
                Our calculator provides an option to compare your local time with Greenwich Mean Time (GMT). It calculates the time remaining until your birthday in GMT and shows how it aligns with your local time zone, ensuring an accurate countdown.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  What is the benefit of knowing the exact time until my birthday?
                </h3>
              </div>
              <div className="info-section-body">
                Knowing the exact time until your birthday helps with planning celebrations and special events. It provides detailed information about the countdown, allowing you to prepare for your birthday with precision and accuracy.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Can I use the calculator to find out the remaining time for someone else's birthday?
                </h3>
              </div>
              <div className="info-section-body">
                Yes, you can use our calculator to find out the remaining time until anyone's birthday by entering their birthdate. This feature allows you to plan gifts, parties, or simply keep track of important dates for loved ones.
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default AgeCalculatorGregorian;